export enum AssetIndexTypes {
    Default,
    Excluded,
    ForReview
}
